import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {ArrowLeft} from '../icons';
import {ALERTS_RULES} from './alertsCenterPaths';

/**
 * Arriba de una página de detalle del Centro (UD-18: editar, crear una alerta, avisos de las cuentas), en lugar del
 * título y las solapas: «← Mis reglas» y la miga («Alertas · Mis reglas · Editar»).
 *
 * `onBack`: si viene, «← Mis reglas» es un botón que lo llama (el editor pregunta antes de descartar cambios); si no,
 * un link a la lista.
 */
export function DetailTop({crumbs = [], onBack = null}) {
    const {t} = useTranslation();
    const label = t('alerts_center.tabs.rules');
    return (
        <div className="alc-ed-top" data-testid="alc-detail-top">
            {onBack ? (
                <button type="button" className="alc-back -button" onClick={onBack} data-testid="alc-back">
                    <ArrowLeft size={14} weight="bold" aria-hidden="true"/>
                    {label}
                </button>
            ) : (
                <Link to={ALERTS_RULES} className="alc-back" data-testid="alc-back">
                    <ArrowLeft size={14} weight="bold" aria-hidden="true"/>
                    {label}
                </Link>
            )}
            {crumbs.length > 0 && <span className="alc-crumbs">{crumbs.join(' · ')}</span>}
        </div>
    );
}

export default DetailTop;
